var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewicon = function SvgViewicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.995 2.4a8.515 8.515 0 0 1 7.995 5.36c.013.08.013.16 0 .24a.649.649 0 0 1-.048.264A8.515 8.515 0 0 1 7.995 13.6 8.515 8.515 0 0 1 .048 8.248.648.648 0 0 1 0 8a.8.8 0 0 1 .048-.264A8.515 8.515 0 0 1 7.995 2.4ZM5.597 8a2.4 2.4 0 1 0 4.798.002A2.4 2.4 0 0 0 5.597 8Z",
    clipRule: "evenodd"
  })));
};
export default SvgViewicon;